import { ContextMenu, Option } from '@philips-internal/oswald-ui-components';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import React from 'react';
import { SCHEDULE_OTHER_STATUS, SCHEDULE_STATUS, WaitingListStatus } from './card-util';
import { generateUUID, isFunction } from '@philips-internal/oswald-ui-utils';
import { ScheduleType } from '../components/pseudonym-suggestion-card-item/pseudonym-suggestion-card-item-type';
import { CONDITION, EXPRESSIONS } from '../constants';
import { AppointmentUtils } from './appointment-utils';
const POSSIBLE_CARDS = {
    APPOINTMENT_DASHBOARD_CARD: 'appointment-dashboard-card',
    CARD_APPOINTMENT: 'card-appointment-0'
};
export class AppointmentCardUtils {
    static getCardAction(appointmentCardUtils) {
        const { alias, allowCancelCheckup, allowConfirmCheckup, ieStatus, ieScheduleType, ieStatusListaEspera, payment, paymentValue, statusWaitingList, scheduleTypeOrigin } = appointmentCardUtils;
        const waiting = alias === POSSIBLE_CARDS.CARD_APPOINTMENT ? ieStatusListaEspera : statusWaitingList;
        const isCancelEnable = this.isEnableCancelAction(allowCancelCheckup, ieStatus, ieScheduleType, waiting);
        const isConfirmEnable = this.isEnableConfirmAction(allowConfirmCheckup, ieStatus, ieScheduleType, waiting);
        const isRescheduleEnable = this.isEnableRescheduleAction(appointmentCardUtils, ieStatus, ieScheduleType, scheduleTypeOrigin);
        const isRescheduleMoreEnable = this.isEnableRescheduleMoreAction(appointmentCardUtils, ieStatus, ieScheduleType, scheduleTypeOrigin);
        const isPaymentEnable = AppointmentUtils.showPaymentLabel(ieStatus, payment, paymentValue);
        if (!isCancelEnable && !isRescheduleEnable && !isRescheduleMoreEnable && !isConfirmEnable && !isPaymentEnable) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement(ContextMenu, { uuid: generateUUID() }, this.renderAction(isCancelEnable, isConfirmEnable, isRescheduleEnable, isRescheduleMoreEnable, isPaymentEnable, appointmentCardUtils)));
    }
    static renderAction(isCancelEnable, isConfirmEnable, isRescheduleEnable, isRescheduleMoreEnable, isPaymentEnable, appointmentCardUtils) {
        const elements = [];
        if (isCancelEnable) {
            elements.push(React.createElement(Option, { value: MessageService.translate(EXPRESSIONS.CANCEL), onClick: () => this.handleClickButtonAppintmentCancel(appointmentCardUtils) }));
        }
        if (isConfirmEnable) {
            elements.push(React.createElement(Option, { value: MessageService.translate(EXPRESSIONS.CONFIRM), onClick: () => this.handleClickButtonAppintmentConfirm(appointmentCardUtils) }));
        }
        if (isRescheduleEnable) {
            elements.push(React.createElement(Option, { value: MessageService.translate(EXPRESSIONS.RESCHEDULE), onClick: () => this.handleClickButtonReSchedule(appointmentCardUtils) }));
        }
        if (isRescheduleMoreEnable) {
            elements.push(React.createElement(Option, { value: MessageService.translate(EXPRESSIONS.RESCHEDULE_MORE), onClick: () => this.handleClickButtonReScheduleMore(appointmentCardUtils) }));
        }
        if (isPaymentEnable) {
            elements.push(React.createElement(Option, { value: MessageService.translate(EXPRESSIONS.PAYMENT), onClick: () => this.handleClickButtonPayment(appointmentCardUtils) }));
        }
        return elements;
    }
    static handleClickButtonReSchedule(appointmentCardUtils) {
        const { onAppointmentReschedule, nrSequencia, ieScheduleType } = appointmentCardUtils;
        if (isFunction(onAppointmentReschedule)) {
            onAppointmentReschedule(nrSequencia, ieScheduleType);
        }
    }
    static handleClickButtonReScheduleMore(appointmentCardUtils) {
        const { onAppointmentRescheduleMore } = appointmentCardUtils;
        if (isFunction(onAppointmentRescheduleMore)) {
            onAppointmentRescheduleMore();
        }
    }
    static handleClickButtonAppintmentCancel(appointmentCardUtils) {
        const { onAppointmentCancel, patientId, nrSequencia, ieScheduleType, ieStatus } = appointmentCardUtils;
        if (isFunction(onAppointmentCancel)) {
            onAppointmentCancel(patientId, ieScheduleType, ieStatus, nrSequencia);
        }
    }
    static handleClickButtonAppintmentConfirm(appointmentCardUtils) {
        const { onAppointmentConfirm, patientId, scheduleCode, nrSequencia, ieScheduleType } = appointmentCardUtils;
        if (isFunction(onAppointmentConfirm)) {
            onAppointmentConfirm(patientId, ieScheduleType, scheduleCode, nrSequencia);
        }
    }
    static handleClickButtonPayment(appointmentCardUtils) {
        const { onPayment, nrSeqAgendaInt } = appointmentCardUtils;
        if (isFunction(onPayment)) {
            onPayment(nrSeqAgendaInt);
        }
    }
    static isEnableCancelAction(allowCancelCheckup, status, scheduleType, statusWaitingList) {
        if (statusWaitingList) {
            return statusWaitingList !== WaitingListStatus.CANCELLED;
        }
        const allowByConfiguration = {
            [ScheduleType.CHECKUP]: allowCancelCheckup,
        };
        if (allowByConfiguration[scheduleType] === CONDITION.NO) {
            return false;
        }
        const allowedScheduleType = [
            ...this.allowedCancelScheduleTypes(),
            ScheduleType.REQUEST,
        ];
        return !this.notAllowedScheduleStatus().includes(status) && allowedScheduleType.includes(scheduleType);
    }
    static isEnableConfirmAction(allowConfirmCheckup, status, scheduleType, statusWaitingList) {
        if (statusWaitingList) {
            return statusWaitingList !== WaitingListStatus.CANCELLED;
        }
        const allowByConfiguration = {
            [ScheduleType.CHECKUP]: allowConfirmCheckup,
        };
        if (allowByConfiguration[scheduleType] === CONDITION.NO) {
            return false;
        }
        const notAllowedScheduleStatus = [
            ...this.notAllowedScheduleStatus(),
            SCHEDULE_STATUS.CONFIRMED,
        ];
        return !notAllowedScheduleStatus.includes(status) && this.allowedScheduleTypes().includes(scheduleType);
    }
    static isEnableRescheduleAction(appointmentCardUtils, status, scheduleType, scheduleTypeOrigin) {
        const { rescheduleCheckup, rescheduleConsultation, rescheduleExam, rescheduleService } = appointmentCardUtils;
        if (scheduleType === ScheduleType.REQUEST) {
            scheduleType = scheduleTypeOrigin || '';
        }
        const rescheduleMap = {
            [ScheduleType.CHECKUP]: rescheduleCheckup,
            [ScheduleType.CONSULTATION]: rescheduleConsultation,
            [ScheduleType.EXAM]: rescheduleExam,
            [ScheduleType.SERVICE]: rescheduleService,
        };
        if (rescheduleMap[scheduleType] === CONDITION.NO) {
            return false;
        }
        return this.allowedScheduleStatus().includes(status) && this.allowedScheduleTypes().includes(scheduleType);
    }
    static isEnableRescheduleMoreAction(appointmentCardUtils, status, scheduleType, scheduleTypeOrigin) {
        const { rescheduleConsultation, rescheduleExam, rescheduleService } = appointmentCardUtils;
        if (scheduleType === ScheduleType.REQUEST) {
            scheduleType = scheduleTypeOrigin ?? '';
        }
        const rescheduleMap = {
            [ScheduleType.CONSULTATION]: rescheduleConsultation,
            [ScheduleType.EXAM]: rescheduleExam,
            [ScheduleType.SERVICE]: rescheduleService,
        };
        if (rescheduleMap[scheduleType] === CONDITION.NO) {
            return false;
        }
        return this.allowedScheduleStatus().includes(status) && this.allowedScheduleMoreTypes().includes(scheduleType);
    }
    static allowedScheduleStatus() {
        return [
            SCHEDULE_OTHER_STATUS.EXECUTION,
            SCHEDULE_STATUS.AWAITING_APPROVAL,
            SCHEDULE_STATUS.NOT_APPROVED,
            SCHEDULE_STATUS.CONFIRMED,
            SCHEDULE_STATUS.APPROVED,
        ];
    }
    static allowedScheduleTypes() {
        return [
            ScheduleType.CHECKUP,
            ScheduleType.CONSULTATION,
            ScheduleType.EXAM,
            ScheduleType.SERVICE
        ];
    }
    static allowedScheduleMoreTypes() {
        return [
            ScheduleType.CONSULTATION,
            ScheduleType.EXAM,
            ScheduleType.SERVICE
        ];
    }
    static notAllowedScheduleStatus() {
        return [
            SCHEDULE_STATUS.CANCELED,
            SCHEDULE_STATUS.MISSED,
            SCHEDULE_STATUS.DONE,
            SCHEDULE_OTHER_STATUS.CANCELED,
            SCHEDULE_OTHER_STATUS.EXECUTION
        ];
    }
    static allowedCancelScheduleTypes() {
        return [
            ScheduleType.CHECKUP,
            ScheduleType.CONSULTATION,
            ScheduleType.EXAM,
            ScheduleType.SERVICE,
            ScheduleType.WAITING_LIST
        ];
    }
}
//# sourceMappingURL=appointment-card-utils.js.map